var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacilityIcon36(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443",
    transform: "translate(-1418 -4233)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(1418 4233)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_car",
    d: "M8.468,4A2.362,2.362,0,0,0,6.234,5.6L3,15.029v12.6a1.576,1.576,0,0,0,1.576,1.576H6.151a1.576,1.576,0,0,0,1.576-1.576V26.057H26.633v1.576a1.576,1.576,0,0,0,1.576,1.576h1.576a1.576,1.576,0,0,0,1.576-1.576v-12.6L28.125,5.6A2.362,2.362,0,0,0,25.891,4Zm.563,3.151h16.3l1.622,4.727H7.41Zm-2.7,7.878h21.7l.179.523v7.354H6.151V15.552ZM10.09,16.6a2.363,2.363,0,1,0,2.363,2.363A2.363,2.363,0,0,0,10.09,16.6Zm14.18,0a2.363,2.363,0,1,0,2.363,2.363A2.363,2.363,0,0,0,24.269,16.6Z",
    transform: "translate(1430.82 4246.396)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityIcon36);
export default __webpack_public_path__ + "static/media/facilityIcon36.08a4dc9895d967814e8c2683d377313b.svg";
export { ForwardRef as ReactComponent };